import React, { useState, useEffect } from 'react';
import FotoWiz from '../img/wiz trans.webp';
import api from '../utils/api';
import ContentLoader from "react-content-loader"

function Home() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const result = await api.getBiodata()
        console.log("result", result)
        setData(result)
        setLoading(false)
      } catch (e) {
        console.error(e)
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  const MyLoader = (props) => (
    <div className={"flex max-w-screen-md md:m-auto"}>
      <ContentLoader
        speed={2}
        width={'100%'}
        
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        <rect x="0" y="0" rx="3" ry="3" width="50%" height="15" />
        <rect x="0" y="20" rx="3" ry="3" width="50%" height="20" />
        <rect x="0" y="45" rx="3" ry="3" width="50%" height="15" />
        <rect x="0" y="80" rx="3" ry="3" width="100%" height="15" />
        <rect x="0" y="100" rx="3" ry="3" width="100%" height="15" />
      </ContentLoader>
    </div>
  )

  return (
    <div>

      <div className={"flex flex-col flex-col-reverse sm:flex-row max-w-screen-md m-auto px-4 sm:px-0"}>

        <div className={"flex-1 mt-2 sm:mt-0 content-center"}>

          {loading ? <MyLoader /> :
            <div className="">
              <div className="">{data.greeting}</div>
              <div className="font-semibold sm:font-normal text-lg sm:text-3xl text-blue-600">{data.name}</div>
              <div className="mb-4">{data.role}</div>

              <div className="mb-4">{data.quote}</div>

              <div className="grid grid-cols-2 gap-2">
                <div className="home-grid-key">Nickname</div><div className="home-grid-val">{data.nickname}</div>
                <div className="home-grid-key">Address</div><div className="home-grid-val">{data.address}</div>
                <div className="home-grid-key">Phone</div><div className="home-grid-val">{data.phone}</div>
                <div className="home-grid-key">Email</div><div className="home-grid-val">{data.email}</div>
                <div className="home-grid-key">Place, birthdate</div><div className="home-grid-val">{data.birthdate}</div>
                <div className="home-grid-key">Religion</div><div className="home-grid-val">{data.religion}</div>
                <div className="home-grid-key">Marital Status</div><div className="home-grid-val">{data.marital}</div>
              </div>
            </div>
          }

        </div>

        <div className={"flex-1 sm:ml-10 w-8/12 m-auto mb-4 sm:mb-0 sm:w-full shadow-md border border-gray-200 rounded"}>
          <img className={"rounded"} src={FotoWiz} alt="Foto Nanang Fitrianto" />
        </div>

      </div>

    </div>
  )
}

export default Home;